import { collectionChoices, collectionSport, newCollection } from './collectionModel.js'
import { createComponent, reconcileManifestCapabilities } from './nativeSportsbookManifest.js'
import { homeScreen } from './nativeScreens.js'

export function availableLeagueHubs(document, catalog) {
  const choices = catalog.choices?.competition_scopes ?? collectionChoices(catalog.events ?? []).competition_scopes
  return choices.filter((choice) => !document.screens.some((screen) => screen.context?.sport === choice.sport && screen.context?.competition?.toLowerCase() === choice.id.toLowerCase()))
    .sort((left, right) => (left.id === 'MLB' ? -1 : right.id === 'MLB' ? 1 : left.name.localeCompare(right.name)))
}

export function addLeagueHub(document, choice, catalog, uuid = () => crypto.randomUUID()) {
  if (!availableLeagueHubs(document, catalog).some((item) => item.sport === choice?.sport && item.id === choice?.id)) throw new Error('Choose a league from the available inventory that does not already have a hub.')
  if (document.screens.length >= 16) throw new Error('This experience has reached its league hub limit.')
  const next = structuredClone(document)
  const id = uuid()
  const games = createComponent('event_list', null, uuid)
  games.title = `${choice.name} games`.slice(0, 80)
  games.collection = { ...newCollection({}, uuid()), sports: [choice.sport], competitions: [choice.id] }
  delete games.event_ids
  delete games.sport_ids
  const notice = homeScreen(document).components.find((component) => component.type === 'compliance_notice')
  if (!notice) throw new Error('Restore the required notice before adding a league hub.')
  const screen = { id, route: `/hub/${id}`, title: choice.name.slice(0, 80), context: { kind: 'competition', sport: choice.sport, competition: choice.id }, components: [games, { ...structuredClone(notice), id: uuid(), slot_id: uuid() }] }
  next.screens.push(screen)
  return { document: reconcileManifestCapabilities(next), screen }
}

export function collectionInHub(definition, context) {
  if (!context) return definition
  if (definition.sports.some((sport) => sport !== context.sport) || definition.competitions.some((competition) => competition.toLowerCase() !== context.competition.toLowerCase())) return null
  return { ...definition, sports: [context.sport], competitions: [context.competition] }
}

export function hubCatalog(catalog, context) {
  if (!context) return catalog
  const events = catalog.events.filter((event) => (event.sport_family || collectionSport(event.sport)) === context.sport && event.league?.toLowerCase() === context.competition.toLowerCase())
  return { ...catalog, events, choices: collectionChoices(events), hub_context: context }
}
